export const url = {
    protocol: 'https',
    host: 'api.dev.clouddirect.biz/v1/',
    port: 3000,
};